/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import CorrectedAddressModalHoc from './CorrectedAddressModalHoc'
import { MODAL_NAMES } from './constants'

export const correctedAllAddressesModal = {
  Component: CorrectedAddressModalHoc(MODAL_NAMES.all),
  name: MODAL_NAMES.all,
}

export const correctedShippingAddressModal = {
  Component: CorrectedAddressModalHoc(MODAL_NAMES.shipping),
  name: MODAL_NAMES.shipping,
}

export const correctedBillingAddressModal = {
  Component: CorrectedAddressModalHoc(MODAL_NAMES.billing),
  name: MODAL_NAMES.billing,
}
